<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatPercent, formatWholeNumber } from '@/utils/poolaReportFormat.js';

const props = defineProps({
  // { distinctBuyerCount, distinctMemberCount, penetrationFraction, unitsSold,
  //   unitsOffered, sellThroughFraction } — see useSupplierDealReport's composeReach.
  reach: { type: Object, required: true },
});

const { t } = useI18n({ useScope: 'global' });

const penetrationWidth = computed(() => formatPercent(props.reach.penetrationFraction));
const sellThroughWidth = computed(() => formatPercent(props.reach.sellThroughFraction));
</script>

<template>
  <div class="report-reach" data-report-section="reach">
    <h2 class="report-section-title">{{ t('poola.report.reach.title') }}</h2>
    <div class="report-reach__card">
      <div class="report-reach__row">
        <p class="report-reach__line">
          {{
            t('poola.report.reach.penetration', {
              x: formatWholeNumber(reach.distinctBuyerCount),
              y: formatWholeNumber(reach.distinctMemberCount),
            })
          }}
        </p>
        <div class="report-reach__bar report-reach__bar--teal">
          <span :style="{ width: penetrationWidth }" />
        </div>
      </div>
      <div class="report-reach__row">
        <p class="report-reach__line">
          {{
            t('poola.report.reach.units', {
              sold: formatWholeNumber(reach.unitsSold),
              offered: formatWholeNumber(reach.unitsOffered),
            })
          }}
        </p>
        <div class="report-reach__bar report-reach__bar--violet">
          <span :style="{ width: sellThroughWidth }" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.report-reach {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding-inline: var(--poolit-spacing-md, 16px);
}

.report-section-title {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: var(--poolit-font-weight-bold, 700);
  color: var(--report-text);
  display: flex;
  align-items: center;
  gap: 7px;
}

.report-reach__card {
  background: var(--report-surface);
  border: 1px solid var(--report-hairline);
  border-radius: var(--poolit-radius-lg, 16px);
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.report-reach__row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.report-reach__line {
  margin: 0;
  font-size: 13.5px;
  font-weight: var(--poolit-font-weight-medium, 500);
  color: var(--report-text);
}

.report-reach__bar {
  height: 9px;
  border-radius: var(--poolit-radius-full, 9999px);
  background: var(--report-surface-2);
  overflow: hidden;
}

.report-reach__bar > span {
  display: block;
  height: 100%;
  border-radius: var(--poolit-radius-full, 9999px);
}

.report-reach__bar--teal > span {
  background: var(--report-teal);
}

.report-reach__bar--violet > span {
  background: var(--report-violet);
}
</style>
